module.exports = __webpack_public_path__ + "bf4560475a1b95717a496ec2cb41bab2.png";